// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-tsx": function componentSrcPages404Tsx() {
    return import("./../../src/pages/404.tsx"
    /* webpackChunkName: "component---src-pages-404-tsx" */
    );
  },
  "component---src-pages-aandoeningen-of-klachten-tsx": function componentSrcPagesAandoeningenOfKlachtenTsx() {
    return import("./../../src/pages/aandoeningen-of-klachten.tsx"
    /* webpackChunkName: "component---src-pages-aandoeningen-of-klachten-tsx" */
    );
  },
  "component---src-pages-afspraak-tsx": function componentSrcPagesAfspraakTsx() {
    return import("./../../src/pages/afspraak.tsx"
    /* webpackChunkName: "component---src-pages-afspraak-tsx" */
    );
  },
  "component---src-pages-huisregels-tsx": function componentSrcPagesHuisregelsTsx() {
    return import("./../../src/pages/huisregels.tsx"
    /* webpackChunkName: "component---src-pages-huisregels-tsx" */
    );
  },
  "component---src-pages-index-tsx": function componentSrcPagesIndexTsx() {
    return import("./../../src/pages/index.tsx"
    /* webpackChunkName: "component---src-pages-index-tsx" */
    );
  },
  "component---src-pages-over-ons-huisregels-tsx": function componentSrcPagesOverOnsHuisregelsTsx() {
    return import("./../../src/pages/over-ons/huisregels.tsx"
    /* webpackChunkName: "component---src-pages-over-ons-huisregels-tsx" */
    );
  },
  "component---src-pages-over-ons-privacy-en-klachten-tsx": function componentSrcPagesOverOnsPrivacyEnKlachtenTsx() {
    return import("./../../src/pages/over-ons/privacy-en-klachten.tsx"
    /* webpackChunkName: "component---src-pages-over-ons-privacy-en-klachten-tsx" */
    );
  },
  "component---src-pages-over-ons-tarieven-tsx": function componentSrcPagesOverOnsTarievenTsx() {
    return import("./../../src/pages/over-ons/tarieven.tsx"
    /* webpackChunkName: "component---src-pages-over-ons-tarieven-tsx" */
    );
  },
  "component---src-pages-over-ons-team-tsx": function componentSrcPagesOverOnsTeamTsx() {
    return import("./../../src/pages/over-ons/team.tsx"
    /* webpackChunkName: "component---src-pages-over-ons-team-tsx" */
    );
  },
  "component---src-pages-portaal-tsx": function componentSrcPagesPortaalTsx() {
    return import("./../../src/pages/portaal.tsx"
    /* webpackChunkName: "component---src-pages-portaal-tsx" */
    );
  },
  "component---src-pages-praktijken-karin-van-havere-tsx": function componentSrcPagesPraktijkenKarinVanHavereTsx() {
    return import("./../../src/pages/praktijken/karin-van-havere.tsx"
    /* webpackChunkName: "component---src-pages-praktijken-karin-van-havere-tsx" */
    );
  },
  "component---src-pages-praktijken-mark-souren-tsx": function componentSrcPagesPraktijkenMarkSourenTsx() {
    return import("./../../src/pages/praktijken/mark-souren.tsx"
    /* webpackChunkName: "component---src-pages-praktijken-mark-souren-tsx" */
    );
  },
  "component---src-pages-success-tsx": function componentSrcPagesSuccessTsx() {
    return import("./../../src/pages/success.tsx"
    /* webpackChunkName: "component---src-pages-success-tsx" */
    );
  }
};